import { join, map } from 'lodash'
import { type FC } from 'react'

import { HStack, Text, VStack, type VStackProps } from '@/components'

export interface ProfileInfoMultiItemProps extends VStackProps {
  label: string
  value: string[] | null | undefined
}

export const ProfileInfoMultiItem: FC<ProfileInfoMultiItemProps> = ({ label, value, ...props }) => (
  <VStack
    accessible
    accessibilityLabel={`${label}: ${join(value, ', ')}`}
    className='gap-2'
    importantForAccessibility='yes'
    tabIndex={0}
    {...props}
  >
    <Text
      accessibilityElementsHidden
      aria-hidden
      className='font-poppinsSemiBold color-white'
      importantForAccessibility='no-hide-descendants'
      numberOfLines={1}
      size='lg'
    >
      {label}
    </Text>
    <HStack
      accessibilityElementsHidden
      aria-hidden
      className='flex-wrap gap-2 pl-2'
      importantForAccessibility='no-hide-descendants'
    >
      {map(value, (item, index) => (
        <Text
          className='rounded-xl bg-white/20 px-3 py-1 text-white'
          key={index}
        >
          {item}
        </Text>
      ))}
    </HStack>
  </VStack>
)
